import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    onText: '',
    offText: ''
  }

  handleOnChangeToggle() {
    let or_and_value = ''
    if ($('.slider-value').is(':checked') === true){
      or_and_value = this.onTextValue;
      $('.toggle-label').text(or_and_value);
    }
    else {
      or_and_value = this.offTextValue;
      $('.toggle-label').text(or_and_value);
    }
  }
}
